/* eslint-disable no-console */
import Vue from 'vue';

Vue.config.errorHandler = (error) => {
    console.log(error)
}